module.exports = __webpack_public_path__ + "img/Curry Icon - white.2f7070ff.svg";